export type OptionalArray<T> = T | T[];

export const resolveOptionalArray = <T>(maybeArray: T | T[]): T[] =>
  Array.isArray(maybeArray) ? maybeArray : [maybeArray];
